import React from 'react';
import PropTypes from 'prop-types';

const Logout = ({ color }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.5 12.127L23.2809 12.7516L23.7806 12.127L23.2809 11.5023L22.5 12.127ZM13.5 11.127C12.9477 11.127 12.5 11.5747 12.5 12.127C12.5 12.6792 12.9477 13.127 13.5 13.127V11.127ZM19.2809 17.7516L23.2809 12.7516L21.7191 11.5023L17.7191 16.5023L19.2809 17.7516ZM23.2809 11.5023L19.2809 6.50226L17.7191 7.75165L21.7191 12.7516L23.2809 11.5023ZM22.5 11.127H13.5V13.127H22.5V11.127Z"
      fill={color}
    />
    <path
      d="M14.5 15.995V16.7384C14.5 18.3568 14.5 19.166 14.026 19.7254C13.5521 20.2849 12.7539 20.418 11.1576 20.684L9.48639 20.9626C6.2433 21.5031 4.62175 21.7733 3.56088 20.8746C2.5 19.9759 2.5 18.332 2.5 15.0442L2.5 9.20972C2.5 5.92189 2.5 4.27797 3.56088 3.37927C4.62175 2.48058 6.2433 2.75084 9.48639 3.29135L11.1576 3.56989C12.7539 3.83594 13.5521 3.96897 14.026 4.52846C14.5 5.08795 14.5 5.89712 14.5 7.51546V8.06099"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

Logout.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Logout;
